import { Button, Typography } from '@mui/material';
import styles from '../ServicesMenu/services.module.scss'
import { useEffect, useState } from 'react';
import YoungadultOverview from './youngadultOverview';
import YoungAdultActivity from './youngAdultActivity';
import YoungAdultGallery from './youngAdultGallery';
import YoundAdultContactus from './youndAdultContactus';


const YoungadultsTabComponent = () => {
    const [activeButton, setActiveButton] = useState<string | null>(null);
    const handleOverviewClick = () => {
        setActiveButton('overview');
    }
    const handleActivityClick = () => {
        setActiveButton('activity');
    }
    const handleConatctUsClick = () => {
        setActiveButton('contactUs');
    }
    const handleGalleryClick = () => {
        setActiveButton('gallery')
    }
    useEffect(() => {
        setActiveButton('overview');
    }, [])

    return (
        <div>
            <div className={styles.servicesMenuTabLayout}>
                <Typography className={styles.typoGraphyHeading}>Young Adult</Typography>
                <div style={{ marginTop: "20px" }}>
                    <div className={styles.buttonContainer}>
                        <Button
                            onClick={handleOverviewClick}
                            className={activeButton === 'overview' ? `${styles.activeButton}` : ''}
                        >
                            <span className={styles.buttonLabelName} style={{ textTransform: 'none' }}>Overview</span>
                        </Button>
                        <Button
                            onClick={handleActivityClick}
                            className={activeButton === 'activity' ? `${styles.activeButton}` : ''}
                        >
                            <span className={styles.buttonLabelName} style={{ textTransform: 'none' }}>Activity</span>
                        </Button>
                        <Button
                            onClick={handleGalleryClick}
                            className={activeButton === 'gallery' ? `${styles.activeButton}` : ''}
                        >
                            <span className={styles.buttonLabelName} style={{ textTransform: 'none' }}>Gallery</span>
                        </Button>
                        <Button
                            onClick={handleConatctUsClick}
                            className={activeButton === 'contactUs' ? `${styles.activeButton}` : ''}
                        >
                            <span className={styles.buttonLabelName} style={{ textTransform: 'none' }}>Contact Us</span>
                        </Button>
                    </div>
                </div>
                <div style={{ borderBottom: '2px solid #D4E2EA' }}></div>
            </div>
            {activeButton === 'overview' && <YoungadultOverview />}
            {activeButton === 'activity' && <YoungAdultActivity />}
            {activeButton === 'gallery' && <YoungAdultGallery/>}
            {activeButton === 'contactUs' && <YoundAdultContactus/>}
        </div>
    )
}
export default YoungadultsTabComponent;